var IfWP = require('./iframe-worker-pool');

class ThumbnailGenerator {

    /**
     * Constructor
     * 
     * iframeBasePath refers to where the iframe that does the thumbing is located
     * 
     * profiling and profilingName is optional. Profiling is measuring the time it takes to generate the thumbs.
     * profiling object should contain two methods:
     * start (profilingName, id)
     * end (profilingName, id)
     * @param {number} maxParallell 
     * @param {string} iframeBasePath 
     * @param {object} profiling 
     * @param {string} profilingName
     */
    constructor(maxParallell, iframeBasePath, profiling, profilingName) {
        this.iframeWorkerPool = new IfWP(iframeBasePath +
            "/resizeworker.html", maxParallell, profiling,
            profilingName);
        this.profiling = profiling;
        this.profilingName = profilingName;
    }

    /**
     * Get a thumbnail created for the given image file. 
     * Returns a promise which resolves with the image data
     * 
     * The size parameter gives the maximum with or height of the thumb
     * 
     * rotationAngle is optional. Specify to rotate the thumbnail. Values 0-360
     * rotationFlip is optional. Specify to flip/mirror the image. Values 'NONE', 'FLIP_HORIZONTAL', 'FLIP_VERTICAL'
     * 
     * @param {string} id 
     * @param {File} file 
     * @param {number} size 
     * @param {number} rotationAngle 
     * @param {string} rotationFlip
     * @returns {Promise}
     */
    getThumbnail(id, file, size, rotationAngle, rotationFlip) {
        return new Promise((resolve, reject) => {
            var url = URL.createObjectURL(file);
            var rotate = rotationAngle > 0 ? rotationAngle : 0;
            var flip = rotationFlip ? rotationFlip : 'NONE';
            
            this.iframeWorkerPool.executeJob(id, {
                    url: url,
                    maxSize: size,
                    rotate: rotate,
                    flip: flip
                }).promise.then(data => {
                    if (this.profiling) {
                        this.profiling.end(this.profilingName, id);
                    }                    
                    resolve(data);
                }).catch(error => {
                    reject(error);
                })
            });
    }
}

module.exports = ThumbnailGenerator